import {Fragment} from "react";
import {SkeletonAccountCell, SkeletonAmountCell} from "../skeletonParts.tsx";
import {COL_SEP_R} from "./tableStyles.ts";

interface StatementTableSkeletonBodyProps {
    sectionColSpan: number;
    amountColumns: number;
    skeletonRowCount: number;
    isSlim: boolean;
    hasComparison: boolean;
}

export function StatementTableSkeletonBody({
    sectionColSpan,
    amountColumns,
    skeletonRowCount,
    isSlim,
    hasComparison,
}: StatementTableSkeletonBodyProps) {
    const rowsPerSection = Math.max(3, Math.ceil(skeletonRowCount / 2));
    const skeletonSections = [
        {title: "Winst & Verlies", key: "pnl"},
        {title: "Balans", key: "balance"},
    ] as const;

    return (
        <>
            {skeletonSections.map((skeletonSection, sectionIndex) => (
                <Fragment key={skeletonSection.key}>
                    <tr className="text-gray-700 [&>*]:[border-top:1px_solid_#d1d5db] [&>*]:[border-bottom:1px_solid_#d1d5db]">
                        <td
                            className={`sticky left-0 z-20 px-3 py-2 text-[12.5px] font-bold uppercase tracking-[0.07em] bg-gray-100 ${COL_SEP_R}`}
                        >
                            {skeletonSection.title}
                        </td>
                        {sectionColSpan > 1 && (
                            <td
                                colSpan={sectionColSpan - 1}
                                className="bg-gray-100"
                                aria-hidden="true"
                            />
                        )}
                    </tr>
                    {Array.from({length: rowsPerSection}, (_, rowIndex) => {
                        const globalIndex = sectionIndex * rowsPerSection + rowIndex;
                        return (
                            <tr
                                key={`${skeletonSection.key}-${rowIndex}`}
                                className="[&>*]:border-b [&>*]:border-b-gray-100"
                            >
                                <SkeletonAccountCell rowIndex={globalIndex} />
                                {Array.from({length: amountColumns}, (_, colIndex) => (
                                    <SkeletonAmountCell
                                        key={colIndex}
                                        rowIndex={globalIndex}
                                        colIndex={colIndex}
                                        withLeftBorder={
                                            isSlim
                                                ? hasComparison && colIndex === 1
                                                : colIndex > 0 && colIndex % 2 === 0
                                        }
                                    />
                                ))}
                            </tr>
                        );
                    })}
                </Fragment>
            ))}
        </>
    );
}
